import 'phoenix_html';
import setupRouter from './routes';

// eslint-disable-next-line no-unused-vars
import css from '../css/app.scss';

// Leightweight scripts
import setupBackButtons from './utility/back-button';
import setupCopyToClipboard from './utility/copy_to_clipboard';
import setupFirebaseMessaging from './firebase';
import setupModals from './utility/modal';
import setupFilter from './utility/tables/filter';
import setupSort from './utility/tables/sort';
import { clearCollapsiblesInLocalStorage, setupCollapsibles } from './utility/collapsibles';

// Could be added to pages only
import setupBulmaComponents from './bulma';
import setupTopbar from './liveview/components/topbar';

// Liveview
import setupLiveview from './liveview';

import searchSelect from './utility/search-select';

const onImpersonateSelect = (e) => {
  window.location = `/impersonate/${e.detail.choice.value}`;
};

function getCallBack(key) {
  switch (key) {
    case 'impersonateUserId':
      return onImpersonateSelect;
    default:
      return null;
  }
}

document.querySelectorAll('.search-select').forEach((el) => {
  searchSelect(el, getCallBack(el.dataset.callback));
});

const preventClickOnDisabledLink = () => {
  document.querySelectorAll('.disabled-link').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });
};

preventClickOnDisabledLink();
document.addEventListener('phx:update', preventClickOnDisabledLink);

setupRouter();
setupModals();
setupLiveview();
setupCopyToClipboard();
setupBackButtons();
setupTopbar();
setupBulmaComponents();
setupFirebaseMessaging();
clearCollapsiblesInLocalStorage();
setupCollapsibles();
document.addEventListener('phx:update', setupCollapsibles);
setupSort('.table.sortable');
setupFilter('.table.filterable');

/*
const hideOnIOS = () => {
  if (/(iPhone|iPad|iPod)/.test(navigator.platform) ||
   (/iPad|iPhone|iPod/.test(navigator.userAgent))) {
    document.querySelectorAll('.hide-on-ios').forEach((el) => {
      console.warn('hiding stuff on iOS');
      // eslint-disable-next-line no-param-reassign
      el.style.visibility = 'hidden';
    });
  }
};
document.addEventListener('DOMContentLoaded', hideOnIOS);
document.addEventListener('phx:update', hideOnIOS);
*/

// Set timezone cookie
const setupTimezoneCookie = () => {
  // timezone string, e.g. "Europe/Zurich"
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  document.cookie = `timezone=${timezone}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT; SameSite=strict;`;
};
setupTimezoneCookie();
